export default __webpack_public_path__ + "static/media/default.38b10efdd306e68aecb546064e76f2f5.png";